import { Globe, Instagram } from "lucide-react";

const iconLinkClass =
  "inline-flex h-10 w-10 items-center justify-center rounded-full border border-borderSoft text-brand-700 transition hover:bg-brand-50 hover:text-brand-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-700 focus-visible:ring-offset-2";

export function Footer() {
  return (
    <footer className="border-t border-borderSoft bg-white py-8">
      <div className="section-shell flex flex-col items-center gap-4 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left">
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:gap-6">
          <p className="text-sm text-ink">© {new Date().getFullYear()} Agentes +10</p>
          <nav className="flex items-center gap-2" aria-label="Redes y web de +10">
            <a
              href="https://www.instagram.com/mas10.ar/"
              target="_blank"
              rel="noopener noreferrer"
              className={iconLinkClass}
              aria-label="Instagram de +10"
            >
              <Instagram size={20} strokeWidth={1.75} aria-hidden />
            </a>
            <a
              href="https://mas10.ar/"
              target="_blank"
              rel="noopener noreferrer"
              className={iconLinkClass}
              aria-label="Sitio web de +10"
            >
              <Globe size={20} strokeWidth={1.75} aria-hidden />
            </a>
          </nav>
        </div>
        <p className="text-sm text-ink">Tecnología aplicada al fútbol, con foco humano.</p>
      </div>
    </footer>
  );
}
